import { LaantypeWeb, SoeknadLaanContainerWeb } from '../../generated-types';

export const MAKS_LAANEANDEL = 0.9;

export const maksLaanebeloep = (soeknadLaan: SoeknadLaanContainerWeb | undefined) => {
    const maksOekning = Math.floor(
        ((soeknadLaan?.eiendomVerdi || 0) + (soeknadLaan?.andelFellesgjeld || 0)) * MAKS_LAANEANDEL -
            (soeknadLaan?.laan.eksisterendeLaanebeloep || 0) -
            (soeknadLaan?.andelFellesgjeld || 0),
    );
    return maksOekning > 0 ? maksOekning : 0;
};

export const nyttLaanebeloep = (eksisterendeLaanebeloep: number, laaneoekning: number) => {
    return eksisterendeLaanebeloep + laaneoekning;
};

export const nyttMaanedligBeloep = (
    eksisterendeLaanebeloep: number,
    laaneoekning: number,
    nominellRente: number,
    antallTerminer: number,
): number => {
    const laanebeloep = nyttLaanebeloep(eksisterendeLaanebeloep, laaneoekning);
    if (laanebeloep <= 0 || nominellRente <= 0 || antallTerminer <= 0) {
        return 0;
    }
    const terminRente = nominellRente / 100 / 12;
    const annuitetsbeloep = (laanebeloep * terminRente) / (1 - (1 + terminRente) ** -antallTerminer);
    return Math.round(annuitetsbeloep);
};

export const belaaningsgrad = (
    boligverdi: number,
    eksisterendeLaanebeloep: number,
    laaneoekning: number,
    andelFellesgjeld: number,
): number => {
    const nyttLaan = eksisterendeLaanebeloep + (laaneoekning || 0) + andelFellesgjeld;
    const prosent = (nyttLaan / (boligverdi + andelFellesgjeld)) * 100;
    return Math.round(prosent);
};

export const showWarning90Precent = (
    soeknadLaan: SoeknadLaanContainerWeb,
    soektBeloep: number | undefined,
): boolean => {
    return (
        soeknadLaan.laan?.laantype !== LaantypeWeb.KREDITT &&
        Number(soektBeloep || 0) + Number(soeknadLaan.laan.eksisterendeLaanebeloep || 0) >
            ((soeknadLaan?.eiendomVerdi || 0) + (soeknadLaan?.andelFellesgjeld || 0)) * MAKS_LAANEANDEL -
                (soeknadLaan?.andelFellesgjeld || 0)
    );
};

export const showWarning60Precent = (
    soeknadLaan: SoeknadLaanContainerWeb,
    soektBeloep: number | undefined,
): boolean => {
    return (
        soeknadLaan.laan?.laantype === LaantypeWeb.KREDITT &&
        Number(soektBeloep || 0) + Number(soeknadLaan.laan.eksisterendeLaanebeloep || 0) >
            ((soeknadLaan?.eiendomVerdi || 0) + (soeknadLaan?.andelFellesgjeld || 0)) * 0.6 -
                (soeknadLaan?.andelFellesgjeld || 0)
    );
};
